import _slicedToArray from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { HandshakeProtocol } from "./HandshakeProtocol";
import { AbortError } from "./Errors";
import { MessageType } from "./IHubProtocol";
import { LogLevel } from "./ILogger";
import { Subject } from "./Subject";
import { Arg, getErrorString, Platform } from "./Utils";
var DEFAULT_TIMEOUT_IN_MS = 30 * 1000;
var DEFAULT_PING_INTERVAL_IN_MS = 15 * 1000;
/** Describes the current state of the {@link HubConnection} to the server. */

export var HubConnectionState;

(function (HubConnectionState) {
  /** The hub connection is disconnected. */
  HubConnectionState["Disconnected"] = "Disconnected";
  /** The hub connection is connecting. */

  HubConnectionState["Connecting"] = "Connecting";
  /** The hub connection is connected. */

  HubConnectionState["Connected"] = "Connected";
  /** The hub connection is disconnecting. */

  HubConnectionState["Disconnecting"] = "Disconnecting";
  /** The hub connection is reconnecting. */

  HubConnectionState["Reconnecting"] = "Reconnecting";
})(HubConnectionState || (HubConnectionState = {}));
/** Represents a connection to a SignalR Hub. */


export var HubConnection =
/*#__PURE__*/
function () {
  function HubConnection(connection, logger, protocol, reconnectPolicy) {
    var _this = this;

    _classCallCheck(this, HubConnection);

    this._nextKeepAlive = 0;

    this._freezeEventListener = function () {
      _this._logger.log(LogLevel.Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://docs.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
    };

    Arg.isRequired(connection, "connection");
    Arg.isRequired(logger, "logger");
    Arg.isRequired(protocol, "protocol");
    this.serverTimeoutInMilliseconds = DEFAULT_TIMEOUT_IN_MS;
    this.keepAliveIntervalInMilliseconds = DEFAULT_PING_INTERVAL_IN_MS;
    this._logger = logger;
    this._protocol = protocol;
    this.connection = connection;
    this._reconnectPolicy = reconnectPolicy;
    this._handshakeProtocol = new HandshakeProtocol();

    this.connection.onreceive = function (data) {
      return _this._processIncomingData(data);
    };

    this.connection.onclose = function (error) {
      return _this._connectionClosed(error);
    };

    this._callbacks = {};
    this._methods = {};
    this._closedCallbacks = [];
    this._reconnectingCallbacks = [];
    this._reconnectedCallbacks = [];
    this._invocationId = 0;
    this._receivedHandshakeResponse = false;
    this._connectionState = HubConnectionState.Disconnected;
    this._connectionStarted = false;
    this._cachedPingMessage = this._protocol.writeMessage({
      type: MessageType.Ping
    });
  }
  /** @internal */
  // Using a public static factory method means we can have a private constructor and an _internal_
  // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
  // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
  // public parameter-less constructor.


  _createClass(HubConnection, [{
    key: "start",

    /** Starts the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
     */
    value: function start() {
      this._startPromise = this._startWithStateTransitions();
      return this._startPromise;
    }
  }, {
    key: "_startWithStateTransitions",
    value: function () {
      var _startWithStateTransitions2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this._connectionState !== HubConnectionState.Disconnected)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state.")));

              case 2:
                this._connectionState = HubConnectionState.Connecting;

                this._logger.log(LogLevel.Debug, "Starting HubConnection.");

                _context.prev = 4;
                _context.next = 7;
                return this._startInternal();

              case 7:
                if (Platform.isBrowser) {
                  // Log when the browser freezes the tab so users know why their connection unexpectedly stopped working
                  window.document.addEventListener("freeze", this._freezeEventListener);
                }

                this._connectionState = HubConnectionState.Connected;
                this._connectionStarted = true;

                this._logger.log(LogLevel.Debug, "HubConnection connected successfully.");

                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](4);
                this._connectionState = HubConnectionState.Disconnected;

                this._logger.log(LogLevel.Debug, "HubConnection failed to start successfully because of error '".concat(_context.t0, "'."));

                return _context.abrupt("return", Promise.reject(_context.t0));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 13]]);
      }));

      function _startWithStateTransitions() {
        return _startWithStateTransitions2.apply(this, arguments);
      }

      return _startWithStateTransitions;
    }()
  }, {
    key: "_startInternal",
    value: function () {
      var _startInternal2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var handshakePromise, handshakeRequest;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._stopDuringStartError = undefined;
                this._receivedHandshakeResponse = false; // Set up the promise before any connection is (re)started otherwise it could race with received messages

                handshakePromise = new Promise(function (resolve, reject) {
                  _this2._handshakeResolver = resolve;
                  _this2._handshakeRejecter = reject;
                });
                _context2.next = 5;
                return this.connection.start(this._protocol.transferFormat);

              case 5:
                _context2.prev = 5;
                handshakeRequest = {
                  protocol: this._protocol.name,
                  version: this._protocol.version
                };

                this._logger.log(LogLevel.Debug, "Sending handshake request.");

                _context2.next = 10;
                return this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(handshakeRequest));

              case 10:
                this._logger.log(LogLevel.Information, "Using HubProtocol '".concat(this._protocol.name, "'.")); // defensively cleanup timeout in case we receive a message from the server before we finish start


                this._cleanupTimeout();

                this._resetTimeoutPeriod();

                this._resetKeepAliveInterval();

                _context2.next = 16;
                return handshakePromise;

              case 16:
                if (!this._stopDuringStartError) {
                  _context2.next = 18;
                  break;
                }

                throw this._stopDuringStartError;

              case 18:
                if (this.connection.features.inherentKeepAlive) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 21;
                return this._sendMessage(this._cachedPingMessage);

              case 21:
                _context2.next = 31;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2["catch"](5);

                this._logger.log(LogLevel.Debug, "Hub handshake failed with error '".concat(_context2.t0, "' during start(). Stopping HubConnection."));

                this._cleanupTimeout();

                this._cleanupPingTimer(); // HttpConnection.stop() should not complete until after the onclose callback is invoked.
                // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.


                _context2.next = 30;
                return this.connection.stop(_context2.t0);

              case 30:
                throw _context2.t0;

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 23]]);
      }));

      function _startInternal() {
        return _startInternal2.apply(this, arguments);
      }

      return _startInternal;
    }()
    /** Stops the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
     */

  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var startPromise;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Capture the start promise before the connection might be restarted in an onclose callback.
                startPromise = this._startPromise;
                this._stopPromise = this._stopInternal();
                _context3.next = 4;
                return this._stopPromise;

              case 4:
                _context3.prev = 4;
                _context3.next = 7;
                return startPromise;

              case 7:
                _context3.next = 11;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](4);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 9]]);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "_stopInternal",
    value: function _stopInternal(error) {
      if (this._connectionState === HubConnectionState.Disconnected) {
        this._logger.log(LogLevel.Debug, "Call to HubConnection.stop(".concat(error, ") ignored because it is already in the disconnected state."));

        return Promise.resolve();
      }

      if (this._connectionState === HubConnectionState.Disconnecting) {
        this._logger.log(LogLevel.Debug, "Call to HttpConnection.stop(".concat(error, ") ignored because the connection is already in the disconnecting state."));

        return this._stopPromise;
      }

      this._connectionState = HubConnectionState.Disconnecting;

      this._logger.log(LogLevel.Debug, "Stopping HubConnection.");

      if (this._reconnectDelayHandle) {
        // We're in a reconnect delay which means the underlying connection is currently already stopped.
        // Just clear the handle to stop the reconnect loop (which no one is waiting on thankfully) and
        // fire the onclose callbacks.
        this._logger.log(LogLevel.Debug, "Connection stopped during reconnect delay. Done reconnecting.");

        clearTimeout(this._reconnectDelayHandle);
        this._reconnectDelayHandle = undefined;

        this._completeClose();

        return Promise.resolve();
      }

      this._cleanupTimeout();

      this._cleanupPingTimer();

      this._stopDuringStartError = error || new AbortError("The connection was stopped before the hub handshake could complete."); // HttpConnection.stop() should not complete until after either HttpConnection.start() fails
      // or the onclose callback is invoked. The onclose callback will transition the HubConnection
      // to the disconnected state if need be before HttpConnection.stop() completes.

      return this.connection.stop(error);
    }
    /** Invokes a streaming hub method on the server using the specified name and arguments.
     *
     * @typeparam T The type of the items returned by the server.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
     */

  }, {
    key: "stream",
    value: function stream(methodName) {
      var _this3 = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var _this$_replaceStreami = this._replaceStreamingParams(args),
          _this$_replaceStreami2 = _slicedToArray(_this$_replaceStreami, 2),
          streams = _this$_replaceStreami2[0],
          streamIds = _this$_replaceStreami2[1];

      var invocationDescriptor = this._createStreamInvocation(methodName, args, streamIds); // eslint-disable-next-line prefer-const


      var promiseQueue;
      var subject = new Subject();

      subject.cancelCallback = function () {
        var cancelInvocation = _this3._createCancelInvocation(invocationDescriptor.invocationId);

        delete _this3._callbacks[invocationDescriptor.invocationId];
        return promiseQueue.then(function () {
          return _this3._sendWithProtocol(cancelInvocation);
        });
      };

      this._callbacks[invocationDescriptor.invocationId] = function (invocationEvent, error) {
        if (error) {
          subject.error(error);
          return;
        } else if (invocationEvent) {
          // invocationEvent will not be null when an error is not passed to the callback
          if (invocationEvent.type === MessageType.Completion) {
            if (invocationEvent.error) {
              subject.error(new Error(invocationEvent.error));
            } else {
              subject.complete();
            }
          } else {
            subject.next(invocationEvent.item);
          }
        }
      };

      promiseQueue = this._sendWithProtocol(invocationDescriptor).catch(function (e) {
        subject.error(e);
        delete _this3._callbacks[invocationDescriptor.invocationId];
      });

      this._launchStreams(streams, promiseQueue);

      return subject;
    }
  }, {
    key: "_sendMessage",
    value: function _sendMessage(message) {
      this._resetKeepAliveInterval();

      return this.connection.send(message);
    }
    /**
     * Sends a js object to the server.
     * @param message The js object to serialize and send.
     */

  }, {
    key: "_sendWithProtocol",
    value: function _sendWithProtocol(message) {
      return this._sendMessage(this._protocol.writeMessage(message));
    }
    /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
     *
     * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
     * be processing the invocation.
     *
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
     */

  }, {
    key: "send",
    value: function send(methodName) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var _this$_replaceStreami3 = this._replaceStreamingParams(args),
          _this$_replaceStreami4 = _slicedToArray(_this$_replaceStreami3, 2),
          streams = _this$_replaceStreami4[0],
          streamIds = _this$_replaceStreami4[1];

      var sendPromise = this._sendWithProtocol(this._createInvocation(methodName, args, true, streamIds));

      this._launchStreams(streams, sendPromise);

      return sendPromise;
    }
    /** Invokes a hub method on the server using the specified name and arguments.
     *
     * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
     * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
     * resolving the Promise.
     *
     * @typeparam T The expected return type.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
     */

  }, {
    key: "invoke",
    value: function invoke(methodName) {
      var _this4 = this;

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      var _this$_replaceStreami5 = this._replaceStreamingParams(args),
          _this$_replaceStreami6 = _slicedToArray(_this$_replaceStreami5, 2),
          streams = _this$_replaceStreami6[0],
          streamIds = _this$_replaceStreami6[1];

      var invocationDescriptor = this._createInvocation(methodName, args, false, streamIds);

      var p = new Promise(function (resolve, reject) {
        // invocationId will always have a value for a non-blocking invocation
        _this4._callbacks[invocationDescriptor.invocationId] = function (invocationEvent, error) {
          if (error) {
            reject(error);
            return;
          } else if (invocationEvent) {
            // invocationEvent will not be null when an error is not passed to the callback
            if (invocationEvent.type === MessageType.Completion) {
              if (invocationEvent.error) {
                reject(new Error(invocationEvent.error));
              } else {
                resolve(invocationEvent.result);
              }
            } else {
              reject(new Error("Unexpected message type: ".concat(invocationEvent.type)));
            }
          }
        };

        var promiseQueue = _this4._sendWithProtocol(invocationDescriptor).catch(function (e) {
          reject(e); // invocationId will always have a value for a non-blocking invocation

          delete _this4._callbacks[invocationDescriptor.invocationId];
        });

        _this4._launchStreams(streams, promiseQueue);
      });
      return p;
    }
  }, {
    key: "on",
    value: function on(methodName, newMethod) {
      if (!methodName || !newMethod) {
        return;
      }

      methodName = methodName.toLowerCase();

      if (!this._methods[methodName]) {
        this._methods[methodName] = [];
      } // Preventing adding the same handler multiple times.


      if (this._methods[methodName].indexOf(newMethod) !== -1) {
        return;
      }

      this._methods[methodName].push(newMethod);
    }
  }, {
    key: "off",
    value: function off(methodName, method) {
      if (!methodName) {
        return;
      }

      methodName = methodName.toLowerCase();
      var handlers = this._methods[methodName];

      if (!handlers) {
        return;
      }

      if (method) {
        var removeIdx = handlers.indexOf(method);

        if (removeIdx !== -1) {
          handlers.splice(removeIdx, 1);

          if (handlers.length === 0) {
            delete this._methods[methodName];
          }
        }
      } else {
        delete this._methods[methodName];
      }
    }
    /** Registers a handler that will be invoked when the connection is closed.
     *
     * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
     */

  }, {
    key: "onclose",
    value: function onclose(callback) {
      if (callback) {
        this._closedCallbacks.push(callback);
      }
    }
    /** Registers a handler that will be invoked when the connection starts reconnecting.
     *
     * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
     */

  }, {
    key: "onreconnecting",
    value: function onreconnecting(callback) {
      if (callback) {
        this._reconnectingCallbacks.push(callback);
      }
    }
    /** Registers a handler that will be invoked when the connection successfully reconnects.
     *
     * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
     */

  }, {
    key: "onreconnected",
    value: function onreconnected(callback) {
      if (callback) {
        this._reconnectedCallbacks.push(callback);
      }
    }
  }, {
    key: "_processIncomingData",
    value: function _processIncomingData(data) {
      this._cleanupTimeout();

      if (!this._receivedHandshakeResponse) {
        data = this._processHandshakeResponse(data);
        this._receivedHandshakeResponse = true;
      } // Data may have all been read when processing handshake response


      if (data) {
        // Parse the messages
        var messages = this._protocol.parseMessages(data, this._logger);

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var message = _step.value;

            switch (message.type) {
              case MessageType.Invocation:
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._invokeClientMethod(message);

                break;

              case MessageType.StreamItem:
              case MessageType.Completion:
                {
                  var callback = this._callbacks[message.invocationId];

                  if (callback) {
                    if (message.type === MessageType.Completion) {
                      delete this._callbacks[message.invocationId];
                    }

                    try {
                      callback(message);
                    } catch (e) {
                      this._logger.log(LogLevel.Error, "Stream callback threw error: ".concat(getErrorString(e)));
                    }
                  }

                  break;
                }

              case MessageType.Ping:
                // Don't care about pings
                break;

              case MessageType.Close:
                {
                  this._logger.log(LogLevel.Information, "Close message received from server.");

                  var error = message.error ? new Error("Server returned an error on close: " + message.error) : undefined;

                  if (message.allowReconnect === true) {
                    // It feels wrong not to await connection.stop() here, but processIncomingData is called as part of an onreceive callback which is not async,
                    // this is already the behavior for serverTimeout(), and HttpConnection.Stop() should catch and log all possible exceptions.
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.connection.stop(error);
                  } else {
                    // We cannot await stopInternal() here, but subsequent calls to stop() will await this if stopInternal() is still ongoing.
                    this._stopPromise = this._stopInternal(error);
                  }

                  break;
                }

              default:
                this._logger.log(LogLevel.Warning, "Invalid message type: ".concat(message.type, "."));

                break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      this._resetTimeoutPeriod();
    }
  }, {
    key: "_processHandshakeResponse",
    value: function _processHandshakeResponse(data) {
      var responseMessage;
      var remainingData;

      try {
        var _this$_handshakeProto = this._handshakeProtocol.parseHandshakeResponse(data);

        var _this$_handshakeProto2 = _slicedToArray(_this$_handshakeProto, 2);

        remainingData = _this$_handshakeProto2[0];
        responseMessage = _this$_handshakeProto2[1];
      } catch (e) {
        var message = "Error parsing handshake response: " + e;

        this._logger.log(LogLevel.Error, message);

        var error = new Error(message);

        this._handshakeRejecter(error);

        throw error;
      }

      if (responseMessage.error) {
        var _message = "Server returned handshake error: " + responseMessage.error;

        this._logger.log(LogLevel.Error, _message);

        var _error = new Error(_message);

        this._handshakeRejecter(_error);

        throw _error;
      } else {
        this._logger.log(LogLevel.Debug, "Server handshake complete.");
      }

      this._handshakeResolver();

      return remainingData;
    }
  }, {
    key: "_resetKeepAliveInterval",
    value: function _resetKeepAliveInterval() {
      if (this.connection.features.inherentKeepAlive) {
        return;
      } // Set the time we want the next keep alive to be sent
      // Timer will be setup on next message receive


      this._nextKeepAlive = new Date().getTime() + this.keepAliveIntervalInMilliseconds;

      this._cleanupPingTimer();
    }
  }, {
    key: "_resetTimeoutPeriod",
    value: function _resetTimeoutPeriod() {
      var _this5 = this;

      if (!this.connection.features || !this.connection.features.inherentKeepAlive) {
        // Set the timeout timer
        this._timeoutHandle = setTimeout(function () {
          return _this5.serverTimeout();
        }, this.serverTimeoutInMilliseconds); // Set keepAlive timer if there isn't one

        if (this._pingServerHandle === undefined) {
          var nextPing = this._nextKeepAlive - new Date().getTime();

          if (nextPing < 0) {
            nextPing = 0;
          } // The timer needs to be set from a networking callback to avoid Chrome timer throttling from causing timers to run once a minute


          this._pingServerHandle = setTimeout(
          /*#__PURE__*/
          _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee4() {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (!(_this5._connectionState === HubConnectionState.Connected)) {
                      _context4.next = 9;
                      break;
                    }

                    _context4.prev = 1;
                    _context4.next = 4;
                    return _this5._sendMessage(_this5._cachedPingMessage);

                  case 4:
                    _context4.next = 9;
                    break;

                  case 6:
                    _context4.prev = 6;
                    _context4.t0 = _context4["catch"](1);

                    // We don't care about the error. It should be seen elsewhere in the client.
                    // The connection is probably in a bad or closed state now, cleanup the timer so it stops triggering
                    _this5._cleanupPingTimer();

                  case 9:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, this, [[1, 6]]);
          })), nextPing);
        }
      }
    } // eslint-disable-next-line @typescript-eslint/naming-convention

  }, {
    key: "serverTimeout",
    value: function serverTimeout() {
      // The server hasn't talked to us in a while. It doesn't like us anymore ... :(
      // Terminate the connection, but we don't need to wait on the promise. This could trigger reconnecting.
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
    }
  }, {
    key: "_invokeClientMethod",
    value: function () {
      var _invokeClientMethod2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(invocationMessage) {
        var methodName, methods, methodsCopy, expectsResponse, res, exception, completionMessage, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, m, prevRes;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                methodName = invocationMessage.target.toLowerCase();
                methods = this._methods[methodName];

                if (methods) {
                  _context5.next = 9;
                  break;
                }

                this._logger.log(LogLevel.Warning, "No client method with the name '".concat(methodName, "' found.")); // No handlers provided by client but the server is expecting a response still, so we send an error


                if (!invocationMessage.invocationId) {
                  _context5.next = 8;
                  break;
                }

                this._logger.log(LogLevel.Warning, "No result given for '".concat(methodName, "' method and invocation ID '").concat(invocationMessage.invocationId, "'."));

                _context5.next = 8;
                return this._sendWithProtocol(this._createCompletionMessage(invocationMessage.invocationId, "Client didn't provide a result.", null));

              case 8:
                return _context5.abrupt("return");

              case 9:
                // Avoid issues with handlers removing themselves thus modifying the list while iterating through it
                methodsCopy = methods.slice(); // Server expects a response

                expectsResponse = invocationMessage.invocationId ? true : false; // We preserve the last result or exception but still call all handlers

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context5.prev = 14;
                _iterator2 = methodsCopy[Symbol.iterator]();

              case 16:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context5.next = 34;
                  break;
                }

                m = _step2.value;
                _context5.prev = 18;
                prevRes = res;
                _context5.next = 22;
                return m.apply(this, invocationMessage.arguments);

              case 22:
                res = _context5.sent;

                if (expectsResponse && res && prevRes) {
                  this._logger.log(LogLevel.Error, "Multiple results provided for '".concat(methodName, "'. Sending error to server."));

                  completionMessage = this._createCompletionMessage(invocationMessage.invocationId, "Client provided multiple results.", null);
                } // Ignore exception if we got a result after, the exception will be logged


                exception = undefined;
                _context5.next = 31;
                break;

              case 27:
                _context5.prev = 27;
                _context5.t0 = _context5["catch"](18);
                exception = _context5.t0;

                this._logger.log(LogLevel.Error, "A callback for the method '".concat(methodName, "' threw error '").concat(_context5.t0, "'."));

              case 31:
                _iteratorNormalCompletion2 = true;
                _context5.next = 16;
                break;

              case 34:
                _context5.next = 40;
                break;

              case 36:
                _context5.prev = 36;
                _context5.t1 = _context5["catch"](14);
                _didIteratorError2 = true;
                _iteratorError2 = _context5.t1;

              case 40:
                _context5.prev = 40;
                _context5.prev = 41;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 43:
                _context5.prev = 43;

                if (!_didIteratorError2) {
                  _context5.next = 46;
                  break;
                }

                throw _iteratorError2;

              case 46:
                return _context5.finish(43);

              case 47:
                return _context5.finish(40);

              case 48:
                if (!completionMessage) {
                  _context5.next = 53;
                  break;
                }

                _context5.next = 51;
                return this._sendWithProtocol(completionMessage);

              case 51:
                _context5.next = 60;
                break;

              case 53:
                if (!expectsResponse) {
                  _context5.next = 59;
                  break;
                }

                // If there is an exception that means either no result was given or a handler after a result threw
                if (exception) {
                  completionMessage = this._createCompletionMessage(invocationMessage.invocationId, "".concat(exception), null);
                } else if (res !== undefined) {
                  completionMessage = this._createCompletionMessage(invocationMessage.invocationId, null, res);
                } else {
                  this._logger.log(LogLevel.Warning, "No result given for '".concat(methodName, "' method and invocation ID '").concat(invocationMessage.invocationId, "'.")); // Client didn't provide a result or throw from a handler, server expects a response so we send an error


                  completionMessage = this._createCompletionMessage(invocationMessage.invocationId, "Client didn't provide a result.", null);
                }

                _context5.next = 57;
                return this._sendWithProtocol(completionMessage);

              case 57:
                _context5.next = 60;
                break;

              case 59:
                if (res) {
                  this._logger.log(LogLevel.Error, "Result given for '".concat(methodName, "' method but server is not expecting a result."));
                }

              case 60:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[14, 36, 40, 48], [18, 27], [41,, 43, 47]]);
      }));

      function _invokeClientMethod(_x) {
        return _invokeClientMethod2.apply(this, arguments);
      }

      return _invokeClientMethod;
    }()
  }, {
    key: "_connectionClosed",
    value: function _connectionClosed(error) {
      this._logger.log(LogLevel.Debug, "HubConnection.connectionClosed(".concat(error, ") called while in state ").concat(this._connectionState, ".")); // Triggering this.handshakeRejecter is insufficient because it could already be resolved without the continuation having run yet.


      this._stopDuringStartError = this._stopDuringStartError || error || new AbortError("The underlying connection was closed before the hub handshake could complete."); // If the handshake is in progress, start will be waiting for the handshake promise, so we complete it.
      // If it has already completed, this should just noop.

      if (this._handshakeResolver) {
        this._handshakeResolver();
      }

      this._cancelCallbacksWithError(error || new Error("Invocation canceled due to the underlying connection being closed."));

      this._cleanupTimeout();

      this._cleanupPingTimer();

      if (this._connectionState === HubConnectionState.Disconnecting) {
        this._completeClose(error);
      } else if (this._connectionState === HubConnectionState.Connected && this._reconnectPolicy) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._reconnect(error);
      } else if (this._connectionState === HubConnectionState.Connected) {
        this._completeClose(error);
      } // If none of the above if conditions were true were called the HubConnection must be in either:
      // 1. The Connecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail it.
      // 2. The Reconnecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail the current reconnect attempt
      //    and potentially continue the reconnect() loop.
      // 3. The Disconnected state in which case we're already done.

    }
  }, {
    key: "_completeClose",
    value: function _completeClose(error) {
      var _this6 = this;

      if (this._connectionStarted) {
        this._connectionState = HubConnectionState.Disconnected;
        this._connectionStarted = false;

        if (Platform.isBrowser) {
          window.document.removeEventListener("freeze", this._freezeEventListener);
        }

        try {
          this._closedCallbacks.forEach(function (c) {
            return c.apply(_this6, [error]);
          });
        } catch (e) {
          this._logger.log(LogLevel.Error, "An onclose callback called with error '".concat(error, "' threw error '").concat(e, "'."));
        }
      }
    }
  }, {
    key: "_reconnect",
    value: function () {
      var _reconnect2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(error) {
        var _this7 = this;

        var reconnectStartTime, previousReconnectAttempts, retryError, nextRetryDelay;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                reconnectStartTime = Date.now();
                previousReconnectAttempts = 0;
                retryError = error !== undefined ? error : new Error("Attempting to reconnect due to a unknown error.");
                nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts++, 0, retryError);

                if (!(nextRetryDelay === null)) {
                  _context6.next = 8;
                  break;
                }

                this._logger.log(LogLevel.Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt.");

                this._completeClose(error);

                return _context6.abrupt("return");

              case 8:
                this._connectionState = HubConnectionState.Reconnecting;

                if (error) {
                  this._logger.log(LogLevel.Information, "Connection reconnecting because of error '".concat(error, "'."));
                } else {
                  this._logger.log(LogLevel.Information, "Connection reconnecting.");
                }

                if (!(this._reconnectingCallbacks.length !== 0)) {
                  _context6.next = 15;
                  break;
                }

                try {
                  this._reconnectingCallbacks.forEach(function (c) {
                    return c.apply(_this7, [error]);
                  });
                } catch (e) {
                  this._logger.log(LogLevel.Error, "An onreconnecting callback called with error '".concat(error, "' threw error '").concat(e, "'."));
                } // Exit early if an onreconnecting callback called connection.stop().


                if (!(this._connectionState !== HubConnectionState.Reconnecting)) {
                  _context6.next = 15;
                  break;
                }

                this._logger.log(LogLevel.Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");

                return _context6.abrupt("return");

              case 15:
                if (!(nextRetryDelay !== null)) {
                  _context6.next = 43;
                  break;
                }

                this._logger.log(LogLevel.Information, "Reconnect attempt number ".concat(previousReconnectAttempts, " will start in ").concat(nextRetryDelay, " ms."));

                _context6.next = 19;
                return new Promise(function (resolve) {
                  _this7._reconnectDelayHandle = setTimeout(resolve, nextRetryDelay);
                });

              case 19:
                this._reconnectDelayHandle = undefined;

                if (!(this._connectionState !== HubConnectionState.Reconnecting)) {
                  _context6.next = 23;
                  break;
                }

                this._logger.log(LogLevel.Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");

                return _context6.abrupt("return");

              case 23:
                _context6.prev = 23;
                _context6.next = 26;
                return this._startInternal();

              case 26:
                this._connectionState = HubConnectionState.Connected;

                this._logger.log(LogLevel.Information, "HubConnection reconnected successfully.");

                if (this._reconnectedCallbacks.length !== 0) {
                  try {
                    this._reconnectedCallbacks.forEach(function (c) {
                      return c.apply(_this7, [_this7.connection.connectionId]);
                    });
                  } catch (e) {
                    this._logger.log(LogLevel.Error, "An onreconnected callback called with connectionId '".concat(this.connection.connectionId, "; threw error '").concat(e, "'."));
                  }
                }

                return _context6.abrupt("return");

              case 32:
                _context6.prev = 32;
                _context6.t0 = _context6["catch"](23);

                this._logger.log(LogLevel.Information, "Reconnect attempt failed because of error '".concat(_context6.t0, "'."));

                if (!(this._connectionState !== HubConnectionState.Reconnecting)) {
                  _context6.next = 39;
                  break;
                }

                this._logger.log(LogLevel.Debug, "Connection moved to the '".concat(this._connectionState, "' from the reconnecting state during reconnect attempt. Done reconnecting.")); // The TypeScript compiler thinks that connectionState must be Connected here. The TypeScript compiler is wrong.


                if (this._connectionState === HubConnectionState.Disconnecting) {
                  this._completeClose();
                }

                return _context6.abrupt("return");

              case 39:
                retryError = _context6.t0 instanceof Error ? _context6.t0 : new Error(_context6.t0.toString());
                nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts++, Date.now() - reconnectStartTime, retryError);

              case 41:
                _context6.next = 15;
                break;

              case 43:
                this._logger.log(LogLevel.Information, "Reconnect retries have been exhausted after ".concat(Date.now() - reconnectStartTime, " ms and ").concat(previousReconnectAttempts, " failed attempts. Connection disconnecting."));

                this._completeClose();

              case 45:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[23, 32]]);
      }));

      function _reconnect(_x2) {
        return _reconnect2.apply(this, arguments);
      }

      return _reconnect;
    }()
  }, {
    key: "_getNextRetryDelay",
    value: function _getNextRetryDelay(previousRetryCount, elapsedMilliseconds, retryReason) {
      try {
        return this._reconnectPolicy.nextRetryDelayInMilliseconds({
          elapsedMilliseconds: elapsedMilliseconds,
          previousRetryCount: previousRetryCount,
          retryReason: retryReason
        });
      } catch (e) {
        this._logger.log(LogLevel.Error, "IRetryPolicy.nextRetryDelayInMilliseconds(".concat(previousRetryCount, ", ").concat(elapsedMilliseconds, ") threw error '").concat(e, "'."));

        return null;
      }
    }
  }, {
    key: "_cancelCallbacksWithError",
    value: function _cancelCallbacksWithError(error) {
      var _this8 = this;

      var callbacks = this._callbacks;
      this._callbacks = {};
      Object.keys(callbacks).forEach(function (key) {
        var callback = callbacks[key];

        try {
          callback(null, error);
        } catch (e) {
          _this8._logger.log(LogLevel.Error, "Stream 'error' callback called with '".concat(error, "' threw error: ").concat(getErrorString(e)));
        }
      });
    }
  }, {
    key: "_cleanupPingTimer",
    value: function _cleanupPingTimer() {
      if (this._pingServerHandle) {
        clearTimeout(this._pingServerHandle);
        this._pingServerHandle = undefined;
      }
    }
  }, {
    key: "_cleanupTimeout",
    value: function _cleanupTimeout() {
      if (this._timeoutHandle) {
        clearTimeout(this._timeoutHandle);
      }
    }
  }, {
    key: "_createInvocation",
    value: function _createInvocation(methodName, args, nonblocking, streamIds) {
      if (nonblocking) {
        if (streamIds.length !== 0) {
          return {
            arguments: args,
            streamIds: streamIds,
            target: methodName,
            type: MessageType.Invocation
          };
        } else {
          return {
            arguments: args,
            target: methodName,
            type: MessageType.Invocation
          };
        }
      } else {
        var invocationId = this._invocationId;
        this._invocationId++;

        if (streamIds.length !== 0) {
          return {
            arguments: args,
            invocationId: invocationId.toString(),
            streamIds: streamIds,
            target: methodName,
            type: MessageType.Invocation
          };
        } else {
          return {
            arguments: args,
            invocationId: invocationId.toString(),
            target: methodName,
            type: MessageType.Invocation
          };
        }
      }
    }
  }, {
    key: "_launchStreams",
    value: function _launchStreams(streams, promiseQueue) {
      var _this9 = this;

      if (streams.length === 0) {
        return;
      } // Synchronize stream data so they arrive in-order on the server


      if (!promiseQueue) {
        promiseQueue = Promise.resolve();
      } // We want to iterate over the keys, since the keys are the stream ids
      // eslint-disable-next-line guard-for-in


      var _loop = function _loop(streamId) {
        streams[streamId].subscribe({
          complete: function complete() {
            promiseQueue = promiseQueue.then(function () {
              return _this9._sendWithProtocol(_this9._createCompletionMessage(streamId));
            });
          },
          error: function error(err) {
            var message;

            if (err instanceof Error) {
              message = err.message;
            } else if (err && err.toString) {
              message = err.toString();
            } else {
              message = "Unknown error";
            }

            promiseQueue = promiseQueue.then(function () {
              return _this9._sendWithProtocol(_this9._createCompletionMessage(streamId, message));
            });
          },
          next: function next(item) {
            promiseQueue = promiseQueue.then(function () {
              return _this9._sendWithProtocol(_this9._createStreamItemMessage(streamId, item));
            });
          }
        });
      };

      for (var streamId in streams) {
        _loop(streamId);
      }
    }
  }, {
    key: "_replaceStreamingParams",
    value: function _replaceStreamingParams(args) {
      var streams = [];
      var streamIds = [];

      for (var i = 0; i < args.length; i++) {
        var argument = args[i];

        if (this._isObservable(argument)) {
          var streamId = this._invocationId;
          this._invocationId++; // Store the stream for later use

          streams[streamId] = argument;
          streamIds.push(streamId.toString()); // remove stream from args

          args.splice(i, 1);
        }
      }

      return [streams, streamIds];
    }
  }, {
    key: "_isObservable",
    value: function _isObservable(arg) {
      // This allows other stream implementations to just work (like rxjs)
      return arg && arg.subscribe && typeof arg.subscribe === "function";
    }
  }, {
    key: "_createStreamInvocation",
    value: function _createStreamInvocation(methodName, args, streamIds) {
      var invocationId = this._invocationId;
      this._invocationId++;

      if (streamIds.length !== 0) {
        return {
          arguments: args,
          invocationId: invocationId.toString(),
          streamIds: streamIds,
          target: methodName,
          type: MessageType.StreamInvocation
        };
      } else {
        return {
          arguments: args,
          invocationId: invocationId.toString(),
          target: methodName,
          type: MessageType.StreamInvocation
        };
      }
    }
  }, {
    key: "_createCancelInvocation",
    value: function _createCancelInvocation(id) {
      return {
        invocationId: id,
        type: MessageType.CancelInvocation
      };
    }
  }, {
    key: "_createStreamItemMessage",
    value: function _createStreamItemMessage(id, item) {
      return {
        invocationId: id,
        item: item,
        type: MessageType.StreamItem
      };
    }
  }, {
    key: "_createCompletionMessage",
    value: function _createCompletionMessage(id, error, result) {
      if (error) {
        return {
          error: error,
          invocationId: id,
          type: MessageType.Completion
        };
      }

      return {
        invocationId: id,
        result: result,
        type: MessageType.Completion
      };
    }
  }, {
    key: "state",

    /** Indicates the state of the {@link HubConnection} to the server. */
    get: function get() {
      return this._connectionState;
    }
    /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
     *  in the disconnected state or if the negotiation step was skipped.
     */

  }, {
    key: "connectionId",
    get: function get() {
      return this.connection ? this.connection.connectionId || null : null;
    }
    /** Indicates the url of the {@link HubConnection} to the server. */

  }, {
    key: "baseUrl",
    get: function get() {
      return this.connection.baseUrl || "";
    }
    /**
     * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
     * Reconnecting states.
     * @param {string} url The url to connect to.
     */
    ,
    set: function set(url) {
      if (this._connectionState !== HubConnectionState.Disconnected && this._connectionState !== HubConnectionState.Reconnecting) {
        throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
      }

      if (!url) {
        throw new Error("The HubConnection url must be a valid url.");
      }

      this.connection.baseUrl = url;
    }
  }], [{
    key: "create",
    value: function create(connection, logger, protocol, reconnectPolicy) {
      return new HubConnection(connection, logger, protocol, reconnectPolicy);
    }
  }]);

  return HubConnection;
}();